/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface ICheckBoxProps {
    id: string;
    fontScale?: number;

    label?: string;
    value?: any[];
    readOnly?: boolean;
    errorText?: string;
    direction?: 'horizontal' | 'vertical';
    options?: { id: string; label: string }[];
    required?: boolean;
    placeholder?: string;
    labelColor?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const CheckBox = ({
    id,
    fontScale,

    label,
    errorText,
    value,
    required,
    options,
    onCompChange,
    labelColor,
    hasError,
    direction,
    readOnly,
}: ICheckBoxProps) => {
    const [textValue, setTextValue] = useState(value ?? []);
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    useEffect(() => {
        if (hasError) {
            setInvalid(hasError);
        }
    }, [hasError]);
    const onChange = (id: string, e: any) => {
        const _textValue = [...(textValue || [])];
        const index = _textValue.indexOf(e?.target?.value);
        console.log('lpo->', _textValue, id, e?.target?.value);
        if (index !== -1) {
            _textValue.splice(index, 1);
        } else {
            _textValue.push(e?.target?.value);
        }
        console.log('lpo->', _textValue, id, e?.target?.value);
        setTextValue([..._textValue]);
        onCompChange && onCompChange(id, _textValue);
        if (isInvalid) {
            setInvalid(false);
        }
    };
    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (isInvalid && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };
    const Comp = direction === 'horizontal' ? InputGroup : React.Fragment;
    return (
        <>
            <Form.Group id={id} className=" formgroup">
                {_renderLabelIf()}
                <Comp>
                    {options?.map(
                        (option, index) => (
                            console.log('ccckkkte', textValue),
                            (
                                <S.FormCheck
                                    style={{
                                        color: textValue?.includes(option.id)
                                            ? 'green'
                                            : 'red',
                                    }}
                                    fontScale={fontScale}
                                    className="formcheck form-check-select mt-1 mb-1"
                                    type={'checkbox'}
                                    label={option?.label}
                                    aria-label={`check-${index + 1}`}
                                    value={option.id}
                                    onChange={onChange.bind(null, id)}
                                    checked={textValue?.includes(option.id)}
                                    key={`check-box-option-${option?.id}-${index}`}
                                    isInvalid={isInvalid}
                                    disabled={readOnly}
                                    readOnly={readOnly}
                                />
                            )
                        )
                    )}
                    {direction === 'horizontal' ? (
                        _renderErrorTextIf()
                    ) : (
                        <InputGroup>{_renderErrorTextIf()}</InputGroup>
                    )}
                </Comp>
            </Form.Group>
        </>
    );
};

CheckBox.defaultProps = {
    direction: 'vertical',
    required: false,
    rootColor: 'grey',
    pointColor: '#000000',
    hasError: false,
    readOnly: false,
};
